import { useMemo } from "react"
import { CommonProperties, MissionControlOrderItem } from "../../common/common.interfaces"
import { Accordion, Card, Col, Container, Row } from "react-bootstrap"
import { RawRow, UniversalConstructorPayload } from "../universalConstructor.interfaces"

interface UniversalConstructorItemPaneProps extends CommonProperties {
  orderWrapper: UniversalConstructorPayload
} 
export default function UniversalConstructorItemPane (props : UniversalConstructorItemPaneProps){


  /**
   * stolen from chatgpt to render the orderitems better
   * @param orderItems 
   * @returns 
   */
  function buildOrderItemElements(orderItems: MissionControlOrderItem[]) {
    if (!orderItems) return
    return orderItems.map((orderItem, index) => {
      const fields = Object.entries(orderItem)
        .filter(([_, value]) => value)
        .map(([field, value]) => (
          <div key={field}>
            {field}: {value}
          </div>
        ))

      return (
        <Card key={index} className="mb-2">
          <Card.Header>Order Item #{index + 1}</Card.Header>
          <Card.Body>{fields}</Card.Body>
        </Card>
      )
    })
  }

  /**
   * stolen from chatgpt to render the raw rows better
   * @param orderItems 
   * @returns 
   */
  function buildOriginalRowElements(rows: RawRow[]) {
    if (!rows) return
    return rows.map((row, index) => {
      const fields = Object.entries(row)
        .filter(([_, value]) => value)
        .map(([field, value]) => (
          <div key={field}>
            {field}: {value}
          </div>
        ))

      return (
        <Card key={index} className="mb-2">
          <Card.Header>Row #{index + 1}</Card.Header>
          <Card.Body>{fields}</Card.Body>
        </Card>
      )
    })
  }

  // #region VIEW
  const view = useMemo(() => {

    const misconOrderFieldDivs = []
    const misconOrderItemFieldDivs = []
    const importFieldDivs = []
    let header = `ORDER COULD NOT BE MAPPED: SEE ERROR`
    
    if (props.orderWrapper.missionControlOrder) {
      header = `ORDER NUMBER: ${props.orderWrapper.missionControlOrder.order.Name}`
    }

    console.log(`${JSON.stringify(Object.entries(props.orderWrapper))}`)

    if(props.orderWrapper.missionControlOrder) {
      for (const [field, value] of Object.entries(props.orderWrapper.missionControlOrder.order)) {
        if(value) {
          misconOrderFieldDivs.push(
            <div>
              {field}: {value}
            </div>
          )
        }
      }
      for (const orderItem of props.orderWrapper.missionControlOrder.orderItems) {
        for (const [field, value] of Object.entries(orderItem)) {
          if(value) {
            misconOrderItemFieldDivs.push(
              <div>
                {field}: {value}
              </div>
            )
          }
        }
      }
    }
  
    return (
      <Row className="p-0 m-0">
        <Accordion className='custom-accordion'>
          <Accordion.Item eventKey='0'>
            <Accordion.Header>{header}</Accordion.Header>
            <Accordion.Body className="d-flex">
              <Container className="p-0">
                <Row className="flex-nowrap">
                  <Col className='md-6'>
                    <Accordion defaultActiveKey="1" className='custom-accordion'>
                      <Accordion.Item eventKey='1'>
                        <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                          <Accordion.Header>IMPORT DATA</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col>
                                <Card>
                                  <Card.Header>Raw Fields</Card.Header>
                                  <Card.Body>
                                    {buildOriginalRowElements(props.orderWrapper.original)}
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </div>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                  <Col className='md-6' hidden={!props.orderWrapper.missionControlOrder}>
                    <Accordion defaultActiveKey="1" className='custom-accordion'>
                      <Accordion.Item eventKey='1'>
                        <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                          <Accordion.Header>MISSION CONTROL DATA</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col>
                                <Card>
                                <Card.Header>Order</Card.Header>
                                  <Card.Body>
                                    {misconOrderFieldDivs}
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <Card className="mb-2">
                                  <Card.Header>Order Items</Card.Header>
                                  <Card.Body>
                                    {buildOrderItemElements(props.orderWrapper.missionControlOrder?.orderItems)}
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </div>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                  <Col className='md-6' hidden={!props.orderWrapper.error}>
                    <Accordion defaultActiveKey="1" className='custom-accordion'>
                      <Accordion.Item eventKey='1'>
                        <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                          <Accordion.Header>ERROR INFO (ADDRESS THE ISSUE OR CONTACT AN ADMINISTRATOR)</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col>
                                <Card className="mb-2">
                                  <Card.Header>Error:</Card.Header>
                                  <Card.Body>
                                    {JSON.stringify(props.orderWrapper.error)}
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </div>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>
              </Container>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
      </Row>
    )
  }, [props.orderWrapper])

  return view
}